import angular from 'angular';

import { attributeFilterComponent } from './filters/attribute-filter/attribute-filter.component';
import { freeformFilterComponent } from './filters/attribute-filter/freeform-filter/freeform-filter.component';
import { listFilterComponent } from './filters/attribute-filter/list-filter/list-filter.component';
import { dateFilterComponent } from './filters/attribute-filter/date-filter/date-filter.component';
import { rangeFilterComponent } from './filters/attribute-filter/range-filter/range-filter.component';
import { FilterInputComponent } from './filters/filter-input/filter-input.component';
import { RangeDateComponent } from './filters/attribute-filter/range-date/range-date.component';
import { EquipmentListController } from './list.controller';
import { assetFiltersComponent } from './filters/filters.component';
import { numericRangeFilterComponent } from './filters/attribute-filter/numeric-range-filter/numeric-range-filter.component';
import { invalidEntryMessagingComponent } from './filters/attribute-filter/invalid-entry-messaging/invalid-entry-messaging.component';
import NoticeComponent from './notice/notice.component';
import highlightsComponent from './notice/highlights/highlights.component';
import FilterOverviewComponent from './filter-overview/filter-overview.component';
const equipmentListModule = angular.module('equipment.list', []);

equipmentListModule
  .controller('EquipmentListController', EquipmentListController)

  .component('invalidEntry', invalidEntryMessagingComponent)
  .component('attributeFilter', attributeFilterComponent)
  .component('freeformFilter', freeformFilterComponent)
  .component('listFilter', listFilterComponent)
  .component('dateFilter', dateFilterComponent)
  .component('rangeFilter', rangeFilterComponent)
  .component('filterInput', FilterInputComponent)
  .component('rangeDate', RangeDateComponent)
  .component('assetSearchFilters', assetFiltersComponent)
  .component('numericRangeFilter', numericRangeFilterComponent)
  .component('notice', NoticeComponent)
  .component('highlights', highlightsComponent)
  .component('filterOverview', FilterOverviewComponent);

export default equipmentListModule.name;
